//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import '../../assets/style/weui.css';
import '../../api/openjsbridge.icity.js'
export default {

  components: {

  },
  data() {
    return {
      unitNo:'',
      amount:'',
      deviceInfo:'',
      dataSource:this.$cookies.get('dataSource'),
      tel:this.$cookies.get('contactNo'),
      commercialName:this.$cookies.get('commercialName'),
      weiJson:'',
      billShow: true,
      resultShow: false,
      zfShow: true,
      zfzShow: false,
      buttonText: '确认缴费',
      reqsn:'',
      timer1:null,
      payOrderDate:'',
      payAmount:'',
      customerNumber: this.$cookies.get('commercialNumber'),

    };
  },
  created() {
    //this.getPayStatus()
    this.deviceInfo=JSON.parse(this.$route.query.deviceInfo)
    console.log(this.deviceInfo)

  },

  mounted() {

    window.history.pushState( null,null, "#/msb/payOrder");
    window.addEventListener("popstate", this.codesReturn, false)

  },
  methods: {
    backpage() {
      this.billShow=true
      this.resultShow= false
      this.zfShow = true
      this.zfzShow = false
      this.buttonText = '确认缴费'
      this.amount=''
      clearInterval(this.timer1)
    },
    codesReturn: async function() {
      clearInterval(this.timer1);

      this.$router.go(-1)
    },
    getPayStatus: async function () {
      const _this = this
      console.log('订单查询')
      let params = {
        commercialNumber:this.$cookies.get('commercialNumber'),
        token:this.$cookies.get('msbToken'),
        reqsn:this.reqsn,

      }
      const response = await this.$api.postjson('/msb/queryOrder', params)
      console.log('订单查询',response)
      if (response.data.code == '0000') {
        _this.payAmount = response.data.data.payAmount / 100
        _this.reqsn = response.data.data.reqsn
        _this.payOrderDate = response.data.data.payOrderDate
        _this.zfShow = true
        _this.zfzShow = false
        _this.billShow=false
        _this.resultShow= true
        _this.buttonText = '确认缴费'
        clearInterval(this.timer1)


      }
      else if (response.data.code == '9992'){

      }
      else if (response.data.code == '9993'){

      }
      else {
        _this.zfShow = true
        _this.zfzShow = false
        _this.buttonText = '确认缴费'
        clearInterval(this.timer1)
        _this.$vux.toast.show({
          text: response.data.msg,
          type: 'warn',
          time: '5000',
        })
      }
    },
    call(tel){
      window.location.href = 'tel://'+tel
    },
    payConfirm(){
      const _this=this
      if(_this.amount==''||_this.amount=='0.00'||_this.amount=='0'){
        _this.$vux.toast.show({
          text: '请输入金额',
          type: "warn",
          time:'3000'
        })
        return
      }
      _this.$vux.confirm.show({
        title: '缴费提醒',
        content: '是否已确认缴费信息正确并缴费？',
        confirmText:'确认缴费',
        onCancel () {
          console.log('plugin cancel')
        },
        onConfirm () {
          _this.payPost()
        }
      })
    },
    payPost: async function(){
      this.zfShow = false
      this.zfzShow = true
      this.buttonText = '支付中'
      const _this=this;
      let params = {
        commercialNumber:this.$cookies.get('commercialNumber'),
        token:this.$cookies.get('msbToken'),
        userCode:this.deviceInfo.userCode,
        amount:this.amount,
        deviceCode:this.deviceInfo.deviceCode,

      };
      console.log(params);
      const response = await this.$api.postjson("/msb/jsPay", params);
      console.log('水费缴纳',response)
      if(response.data.code=='0000'){
        _this.weiJson = response.data.data.pay_INFO
        _this.reqsn=response.data.data.req_SN

        /*查看支付状态*/
        let count =30
        if (!_this.timer1) {
          _this.timer1 = setInterval(() => {
            if (count > 0 && count <= 30) {
              _this.getPayStatus()
              count--
            } else {
              _this.zfShow = true
              _this.zfzShow = false
              _this.buttonText = '确认缴费'
              _this.$vux.toast.show({
                text: "如已支付成功，请稍后查询",
                type: "warn",
                time:'3000'
              })
              clearInterval( _this.timer1);
              _this.timer1 = null;
            }
          }, 3000)

        }


      /*  _this.timer1 = setInterval(function(){
          _this.getPayStatus()
        },3000)*/

        _this.doWeixin()
      }
      else{
        _this.zfShow = true
        _this.zfzShow = false
        _this.buttonText = '确认缴费'
        _this.$vux.toast.show({
          text: response.data.msg,
          type: "warn",
          time:'3000'
        })
      }
    },
    doWeixin:function() {
      const _this = this
      let json = JSON.parse(_this.weiJson)

      iCityBridge.init(function(hasLogin) {
        //hasLogin true:已登录，false:未登录


        iCityBridge.wxPay({
          appid:json.appid,
          timestamp:json.timestamp,
          noncestr:json.noncestr,
          package: json.package,
          sign:json.sign,
          partnerid:json.partnerid,
          prepayid:json.prepayid,

        })
          .then(res => {
            _this.$vux.toast.show({
              text: '支付成功',
              type: 'success',
              time: '5000',
            })
            _this.getBillList()
          })
          .catch(res => {
            _this.$vux.toast.show({
              text: '支付失败',
              type: 'warn',
              time: '3000',
            })
          })
      });

    },





  }
};



// WEBPACK FOOTER //
// ./src/views/msb/payOrder.vue